import { gql } from "@apollo/client";

export const GET_GAMES = gql`
  query GetGames($first: Int, $page: Int, $orderBy: [QueryGamesOrderByOrderByClause!]) {
    games(first: $first, page: $page, orderBy: $orderBy) {
      paginatorInfo {
        currentPage
        total
        lastPage
        hasMorePages
      }
      data {
        id
        title
        link_site
        active
        placement
        row_order
      }
    }
  }
`;

export const GET_GAMES_ORDER = gql`
  query GetGamesOrder($first: Int, $page: Int, $orderBy: [QueryGamesOrderByOrderByClause!]) {
    games(first: $first, page: $page, orderBy: $orderBy) {
      paginatorInfo {
        currentPage
        total
        lastPage
        hasMorePages
      }
      data {
        id
        row_order
      }
    }
  }
`;
